module.exports = __webpack_public_path__ + "media/images/polygon_1-d5ceb9d32e99fe51240221a699f1921a.svg";